module.exports = __webpack_public_path__ + "img/no_record.c1cfbbe6.png";